import { CARRIERS_DATA, SERVICES_DATA, CARRIERS_SERVICE_CODES } from '../actions/actionType'

const initialState = {
  carriers: [],
  services: [],
  carriersServiceCodes: [],
}
export default function CarriersReducer(state = initialState, action) {
  switch (action.type) {
    case CARRIERS_DATA:
      return { ...state, carriers: action.payload }
    case SERVICES_DATA:
      return { ...state, services: action.payload }
    case CARRIERS_SERVICE_CODES:
      return { ...state, carriersServiceCodes: action.payload }
    default:
      return state
  }
}
